import React, { MouseEventHandler } from 'react';

import { FormControl, FormControlLabel, Radio, RadioGroup, Typography, styled } from 'netline-ui';
import { PreferenceSelectorOption } from 'types';

import styles, { mobileRadioGroupPreferenceClasses } from './MobileRadioGroupPreference.styles';

type MobileRadioGroupPreferenceProps = {
  title?: string;
  value: string;
  items: PreferenceSelectorOption[];
  onChange: MouseEventHandler<HTMLButtonElement>;
} & React.HTMLAttributes<HTMLDivElement>;

const MobileRadioGroupPreferenceRoot = styled('div', { name: mobileRadioGroupPreferenceClasses.$name })(styles);

const MobileRadioGroupPreference = ({ title, value, items, onChange, ...rest }: MobileRadioGroupPreferenceProps) => {
  return (
    <MobileRadioGroupPreferenceRoot
      className={mobileRadioGroupPreferenceClasses.root}
      data-testid="MobileRadioGroupPreference-root"
      {...rest}
    >
      {title && <Typography className={mobileRadioGroupPreferenceClasses.title}>{title}</Typography>}
      <FormControl className={mobileRadioGroupPreferenceClasses.radioGroupWrapper}>
        <RadioGroup value={value}>
          {items.map((item) => (
            <FormControlLabel
              key={item.id || `${item.value}`}
              className={mobileRadioGroupPreferenceClasses.radio}
              control={<Radio onChange={onChange} />}
              {...item}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </MobileRadioGroupPreferenceRoot>
  );
};

export default MobileRadioGroupPreference;
